module.exports = __webpack_public_path__ + "static/img/04.1411e0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/04.png
// module id = 0RCW
// module chunks = 1